import Compliance from "lib/api-compliance"
import { omit } from "lodash"
import { Prospect } from "types/entity"
import { CustomerApi } from "types/payload"
import { Action, ActionWithoutPayload, Message } from "types/redux"
import {
  SIGNUP_REQUEST,
  SIGNUP_ERROR,
  SIGNUP_SUCCESS,
  RESET_SIGNUP_STORE,
  CHECK_EXISTING_REGISTERED_PHONE,
  SET_ALREADY_EXISTING_PHONE,
} from "./constants"
import { languages } from "locales/languages"

const actions = {
  request: (payload: Prospect): Action<Partial<CustomerApi>> => {
    return {
      type: SIGNUP_REQUEST,
      payload: omit(
        new Compliance<Prospect, CustomerApi>(payload).please() as CustomerApi,
        "nir"
      ),
    }
  },
  error: (error: string): Action<Message> => ({
    type: SIGNUP_ERROR,
    payload: { text: error || "Error signup", type: "error" },
  }),

  success: (success?: string): Action<Message> => ({
    type: SIGNUP_SUCCESS,
    payload: {
      text: success || languages.weHaveSendAnSms,
      type: "success",
    },
  }),
  reset: (): ActionWithoutPayload => ({ type: RESET_SIGNUP_STORE }),
  checkExistingRegisteredPhone: (payload: { email: string; phone: string }): Action<{ email: string; phone: string }> => ({
    type: CHECK_EXISTING_REGISTERED_PHONE,
    payload,
  }),
  setAlreadyExistingPhone: (phone: string | null | undefined): Action<string | null | undefined> => ({
    type: SET_ALREADY_EXISTING_PHONE,
    payload: phone,
  }),
}
export default actions
